export default __webpack_public_path__ + "static/media/login-bg.7abbcc65.webp";